module.exports = __webpack_public_path__ + "img/header-atractivos.80729281.jpg";